// Tenantra Inc. - Shared public footer
import { Linkedin, Twitter, Instagram, Facebook, Youtube, Send } from 'lucide-react';
import { Logo } from '@/components/Logo';

const COLUMNS = [
  { title: 'For Landlords', links: [
    { label: 'Rent Reporting', href: '/rent-reporting' },
    { label: 'Rent Collection', href: '/rent-collection' },
    { label: 'Tenant Screening', href: '/screening' },
    { label: 'Register', href: '/register' },
    { label: 'How It Works', href: '/#how-it-works' },
    { label: 'Pricing', href: '/#pricing' },
  ]},
  { title: 'For Tenants', links: [
    { label: 'View Report', href: '/tenant/access' },
    { label: 'Dispute Process', href: '/faq' },
    { label: 'FAQs', href: '/faq' },
  ]},
  { title: 'Community', links: [
    { label: 'Ecosystem & Roadmap', href: '/community' },
    { label: 'Whitepaper', href: '/whitepaper' },
    { label: 'Play Aviator Game', href: 'https://t.me/teaborabora_bot/tentgame', external: true },
    { label: 'Join Telegram', href: 'https://t.me/tenantra', external: true },
    { label: 'Careers', href: '/careers' },
  ]},
  { title: 'Legal', links: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms-of-service' },
    { label: 'Data Protection', href: '/data-protection' },
  ]},
];

const SOCIAL = [
  { name: 'LinkedIn', icon: Linkedin, id: 'linkedin' },
  { name: 'X', icon: Twitter, id: 'twitter' },
  { name: 'Instagram', icon: Instagram, id: 'instagram' },
  { name: 'Facebook', icon: Facebook, id: 'facebook', href: 'https://www.facebook.com/share/1DakTVbH3C/?mibextid=wwXIfr' },
  { name: 'YouTube', icon: Youtube, id: 'youtube' },
  { name: 'Telegram', icon: Send, id: 'telegram' },
];

export const PublicFooter = () => (
  <footer className="py-12 sm:py-16 border-t border-stone-200 bg-white" data-testid="public-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-8 sm:gap-10 mb-10 sm:mb-12">
        <div className="col-span-2 md:col-span-1">
          <Logo size="md" className="mb-4" data-testid="footer-logo" />
          <p className="text-sm text-stone-600 leading-relaxed max-w-[220px]">
            Canada's rental behaviour bureau.
          </p>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.14em] mb-4 text-stone-500">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="inline-block py-1.5 sm:py-0 text-sm text-stone-800 hover:text-teal-700 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="pt-6 border-t border-stone-200 flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="text-xs text-stone-500">© {new Date().getFullYear()} Tenantra Inc. All rights reserved.</p>
        <div className="flex items-center gap-5" data-testid="footer-social-row">
          {SOCIAL.map((s) => (
            <a key={s.id} href={s.href || '#'} target={s.href ? '_blank' : undefined} rel={s.href ? 'noopener noreferrer' : undefined} aria-label={s.name} title={s.name} data-testid={`footer-social-${s.id}`} className="p-2 -m-1 text-stone-600 hover:text-teal-700 transition-colors duration-200">
              <s.icon className="w-5 h-5" strokeWidth={1.75} />
            </a>
          ))}
        </div>
        <p className="text-xs text-stone-500">256-bit encryption · PIPEDA compliant</p>
      </div>
    </div>
  </footer>
);
